<div class="share-dialog">
  <header class="header">
    <div class="heading">
      <div class="heading-icon"><mat-icon>group_add</mat-icon></div>
      <div class="titles">
        <h2 mat-dialog-title translate="MEETINGS.SHARE_DIALOG.TITLE"></h2>
        <p class="subtitle mask-meeting-name" [matTooltip]="meeting.name" matTooltipClass="mask-meeting-name">{{ meeting.name }}</p>
      </div>
    </div>
    <button mat-icon-button class="close-button" [mat-dialog-close]="null" [attr.aria-label]="'COMMON.CLOSE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  @if (canEdit) {
    <section class="invite">
      <div class="invite-row">
        <div class="invite-bar" matAutocompleteOrigin #origin="matAutocompleteOrigin">
          <mat-icon class="search-icon">person_search</mat-icon>
          <input
            type="text"
            name="share-target"
            autocomplete="off"
            [placeholder]="'MEETINGS.SHARE_DIALOG.USER_INPUT' | translate"
            [(ngModel)]="email"
            (input)="filterTeamUsers(shareTarget.value.toLowerCase()); userToShareTo = null"
            (focus)="filterTeamUsers(shareTarget.value.toLowerCase())"
            [matAutocomplete]="auto"
            [matAutocompleteConnectedTo]="origin"
            #shareTarget
          />
          <button type="button" class="level-trigger" [matMenuTriggerFor]="newShareLevelMenu">
            {{ 'MEETINGS.SHARE_DIALOG.LEVELS.' + level | translate }}
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>
        <button mat-flat-button color="primary" class="share-button" (click)="shareMeeting()" [disabled]="!isValidInput() || (isSharePending$ | async)">
          @if (isSharePending$ | async) {
            <app-spinner size="small"></app-spinner>
          } @else {
            {{ 'COMMON.SHARE' | translate }}
          }
        </button>
      </div>

      @if (isValidInput()) {
        <mat-checkbox class="notify-checkbox" [(ngModel)]="notifyByEmail">
          {{ 'MEETINGS.SHARE_DIALOG.NOTIFY_BY_EMAIL' | translate }}
        </mat-checkbox>
      }

      <mat-autocomplete
        class="share-autocomplete"
        [displayWith]="displayUserOnAutocomplete"
        (optionSelected)="userToShareTo = $event.option.value"
        #auto="matAutocomplete"
      >
        @for (user of filteredTeamUsers; track user.id) {
          <mat-option [value]="user">
            <div class="suggestion">
              <app-avatar [input]="user | userName" size="small"></app-avatar>
              <div class="identity">
                <span class="name">{{ user | userName }}</span>
                <span class="email">{{ user.email }}</span>
              </div>
            </div>
          </mat-option>
        }
      </mat-autocomplete>

      <mat-menu #newShareLevelMenu="matMenu" xPosition="before">
        @for (option of levels; track option) {
          <button mat-menu-item (click)="level = option">
            <mat-icon [class.hidden]="level !== option">check</mat-icon>
            <span>{{ 'MEETINGS.SHARE_DIALOG.LEVELS.' + option | translate }}</span>
          </button>
        }
      </mat-menu>
    </section>
  }

  <section class="people">
    <div class="section-header">
      <h3 translate="MEETINGS.SHARE_DIALOG.CURRENT_SHARES"></h3>
      <span class="count">{{ meeting.users.length + meeting.shares.length }}</span>
    </div>

    <ul class="people-list">
      @for (user of meeting.users; track user.id) {
        <li class="person">
          <app-avatar [input]="user | userName" size="small"></app-avatar>
          <div class="identity">
            <span class="name">
              {{ user | userName }}
              @if (user.id === currentUserId) {
                <span class="you">({{ 'MEETINGS.SHARE_DIALOG.YOU' | translate }})</span>
              }
            </span>
            <span class="email">{{ user.email }}</span>
          </div>
          <span class="role-tag owner">{{ 'COMMON.MEETING_OWNER' | translate }}</span>
        </li>
      }

      @for (share of meeting.shares; track share.sharedUserId) {
        <li class="person">
          <app-avatar [input]="share.sharedUser | userName" size="small"></app-avatar>
          <div class="identity">
            <span class="name">
              {{ share.sharedUser | userName }}
              @if (share.sharedUserId === currentUserId) {
                <span class="you">({{ 'MEETINGS.SHARE_DIALOG.YOU' | translate }})</span>
              }
            </span>
            <span class="email">{{ share.sharedUser.email }}</span>
          </div>
          @if (canEdit) {
            <button
              type="button"
              class="level-trigger"
              [matMenuTriggerFor]="shareMenu"
              [matMenuTriggerData]="{ share }"
              [attr.aria-label]="
                'MEETINGS.SHARE_DIALOG.ACCESS_LEVEL_FOR'
                  | translate: { userName: share.sharedUser | userName, level: 'MEETINGS.SHARE_DIALOG.LEVELS.' + share.level | translate }
              "
            >
              {{ 'MEETINGS.SHARE_DIALOG.LEVELS.' + share.level | translate }}
              <mat-icon>expand_more</mat-icon>
            </button>
          } @else {
            <span class="role-tag">{{ 'MEETINGS.SHARE_DIALOG.LEVELS.' + share.level | translate }}</span>
          }
        </li>
      }
    </ul>
  </section>

  <mat-menu #shareMenu="matMenu" xPosition="before">
    <ng-template matMenuContent let-share="share">
      @for (option of levels; track option) {
        <button mat-menu-item (click)="option !== share.level && updateShareLevel(share, option)">
          <mat-icon [class.hidden]="share.level !== option">check</mat-icon>
          <span>{{ 'MEETINGS.SHARE_DIALOG.LEVELS.' + option | translate }}</span>
        </button>
      }
      <mat-divider></mat-divider>
      <button mat-menu-item class="remove-item" (click)="removeShare(share.sharedUser)">
        <mat-icon>person_remove</mat-icon>
        <span translate="MEETINGS.SHARE_DIALOG.REMOVE_ACCESS"></span>
      </button>
    </ng-template>
  </mat-menu>

  <footer class="footer">
    <button mat-flat-button color="primary" [mat-dialog-close]="null" cdkFocusInitial translate="COMMON.DONE"></button>
  </footer>
</div>
